export enum DndCardGroup {
  UNASSIGNED = "UNASSIGNED",
  TOP4 = "TOP4",
  OVERALL_TOP4 = "OVERALL_TOP4",
  SHARED_TOP4 = "SHARED_TOP4",
}
